interface IHoldCapabilityConfigurationObject {
  ngStatusBarService?: any;
  appBrowserArguments: string;
}

export class HoldCapabilityConfiguration {
  private _config: IHoldCapabilityConfigurationObject;

  constructor() {
    this._config = {
      appBrowserArguments: ''
    };
  }

  get config(): IHoldCapabilityConfigurationObject {
    return this._config;
  }

  setConfigs(configs: Partial<IHoldCapabilityConfigurationObject>): void {
    this._config = { ...this._config, ...configs };
  }

  setConfig(key: string, value: any): void {
    this._config[key] = value;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/configuration.ts